var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwittercontact(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 4,
    viewBox: "0 0 6 4",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.72222 0.539663C5.54453 0.620433 5.35299 0.67351 5.15453 0.698894C5.35761 0.576587 5.51453 0.38274 5.58838 0.149663C5.39684 0.265048 5.18453 0.345817 4.96069 0.391971C4.77838 0.19351 4.52222 0.078125 4.23145 0.078125C3.68915 0.078125 3.24607 0.521202 3.24607 1.06812C3.24607 1.14659 3.2553 1.22274 3.27145 1.29428C2.44992 1.25274 1.71838 0.858125 1.23145 0.260433C1.14607 0.405817 1.09761 0.576587 1.09761 0.756587C1.09761 1.10043 1.27069 1.40505 1.53838 1.57813C1.37453 1.57813 1.22222 1.53197 1.08838 1.46274V1.46966C1.08838 1.94966 1.42992 2.3512 1.88222 2.4412C1.73701 2.48094 1.58455 2.48647 1.43684 2.45736C1.49952 2.65408 1.62227 2.82622 1.78784 2.94957C1.95342 3.07292 2.15348 3.14128 2.35992 3.14505C2.00998 3.42207 1.57622 3.57181 1.12992 3.56966C1.05145 3.56966 0.972993 3.56505 0.894531 3.55582C1.33299 3.83736 1.85453 4.0012 2.41299 4.0012C4.23145 4.0012 5.23069 2.49197 5.23069 1.18351C5.23069 1.13966 5.23069 1.09812 5.22838 1.05428C5.42222 0.915817 5.58838 0.740433 5.72222 0.539663Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwittercontact);
export default __webpack_public_path__ + "static/media/twittercontact.bac98b320b317ae669ef54ea02b66d36.svg";
export { ForwardRef as ReactComponent };